module.exports = __webpack_public_path__ + "img/Adam.69f443da.jpg";